import React from "react";

export const ChantIcon = ({size = 20, ...props}) => {
	return (
		<svg
			viewBox="0 0 64 64"
			height={size}
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g data-name="26 Bell">
				<path
					d="M55 40h-2v-2a2 2 0 00-4 0v12a2 2 0 004 0v-6h2a2 2 0 000-4z"
					fill="#48005f"
				/>
				<path
					d="M51 47.51v-7a2.49 2.49 0 00-2-2.44v2h-2a2 2 0 000 4h2v6a2.49 2.49 0 002-2.56z"
					fill="#6d337f"
				/>
				<path d="M8.24 53L6 58h-.24a3 3 0 102.48-5z" fill="#fba037" />
				<path
					d="M9 55a3 3 0 00-.76-2H8a3 3 0 00-2.24 5H6a3 3 0 003-3z"
					fill="#fdce72"
				/>
				<g fill="#eee1dc">
					<path d="M60 16a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM59 23a1 1 0 01-.71-.29 1 1 0 010-1.42l.71-.7V19a1 1 0 012 0v2a1 1 0 01-.29.71l-1 1A1 1 0 0159 23zM54 28a1 1 0 01-.71-.29 1 1 0 010-1.42l2-2a1 1 0 011.42 1.42l-2 2A1 1 0 0154 28zM51 33a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1z" />
				</g>
				<path
					d="M51 37a3 3 0 113-3 3 3 0 01-3 3zm0-4a1 1 0 101 1 1 1 0 00-1-1z"
					fill="#f6efea"
				/>
				<path
					d="M31.74 27.62a5.34 5.34 0 00-.74 2.7V32l1 1h1.61a5.48 5.48 0 004.91-3L37 27zM52.92 9.17L37 27l2.76 1.35.05-.06L50.48 19A13.23 13.23 0 0055 9a14.47 14.47 0 00-2.08.17z"
					fill="#77026d"
				/>
				<path
					d="M37 27l-.41 1 1.94 1.94a5.61 5.61 0 011.23-1.59l-1.55-1.56z"
					fill="#eee1dc"
				/>
				<path
					d="M43.59 14.43l-7.86 9.67a1.14 1.14 0 01-.11.11L37 27l1.21-.21 13.38-13.38a4.82 4.82 0 001.33-4.24 14.68 14.68 0 00-9.33 5.26zM36.59 28l.41-1-3-1.54-.08.06a5.21 5.21 0 00-2.23 2.1 4.8 4.8 0 004.9.38z"
					fill="#931188"
				/>
				<path
					d="M34.05 25.46L36.59 28a4.66 4.66 0 001.32-.91l.3-.3-2.59-2.58a5.29 5.29 0 01-1.57 1.25z"
					fill="#f6efea"
				/>
				<path
					d="M57 11a4 4 0 114-4 4 4 0 01-4 4zm0-6a2 2 0 102 2 2 2 0 00-2-2z"
					fill="#eee1dc"
				/>
				<path
					d="M58 7a1 1 0 01-.71-.29 1 1 0 010-1.42l3-3a1 1 0 111.42 1.42l-3 3A1 1 0 0158 7z"
					fill="#f6efea"
				/>
				<path
					d="M31.52 31.55a10.06 10.06 0 00-2-1.32l-15.79 20.5 8.56 8.56a1 1 0 001.71-.7v-2.93a4 4 0 011.17-2.83L28 50l1-2 2-1 1-1a9.9 9.9 0 00-.48-14.45z"
					fill="#ff7c35"
				/>
				<path
					d="M31 36.5a14.47 14.47 0 00-1.44-6.27 9.64 9.64 0 00-1.56-.64S12 44 4.89 40.15a1 1 0 00-.18 1.56l9 9a14.87 14.87 0 002.79.29 14.43 14.43 0 009.2-3.3L26 45l2.56-.44A14.48 14.48 0 0031 36.5z"
					fill="#fba037"
				/>
				<path
					d="M20 40l3.23-.77A14.46 14.46 0 0028 29.59a10.38 10.38 0 00-10.19 2.65l-6.59 6.59A4 4 0 018.34 40H5.41a1 1 0 00-.52.15 14.42 14.42 0 0014.74 1.48z"
					fill="#fdce72"
				/>
				<path d="M25.7 47.7L28 50l3-3-2.45-2.45L26 45z" fill="#e0d2cd" />
				<path
					d="M19.63 41.63l6.07 6.07a14.73 14.73 0 002.86-3.14l-5.33-5.33L21 40z"
					fill="#eee1dc"
				/>
				<path d="M17 33l-3 3 5.63 5.63a14.6 14.6 0 003.6-2.4z" fill="#f6efea" />
			</g>
		</svg>
	);
}

export default ChantIcon;
